import {
  Categories,
  BuffetCategories as BuffetCategoriesEnum,
  AppMenuItemsPos,
  FavoriteStatus,
  VoDType
} from "@/helpers/constants";

export interface AxiosHeaders {
  Accept: string;
  "Content-Type": string;
  Token?: string;
  Mac?: string;
  Authorization?: string;
  DeviceId?: string;
}

export interface LoginCredentialsDto {
  username: string;
  password: string;
}

export enum UserRole {
  Parent = "parent",
  Child = "child"
}
export interface UserProfile {
  first_name: string;
  last_name: string;
  mobile_number?: string;
  birth?: string | null;
}

export interface UserLanguage {
  id: number;
  name: string;
  code: string;
}
export interface Link {
  href: string;
}
export interface Links {
  self: Link[];
}

export interface UserInfo {
  id: number;
  username: string;
  email: string;
  role: UserRole;
  user_channel_package_id: number;
  provider_id?: number;
  user_vod_package_id?: number;
  user_storage_package_id?: number | null;
  user_profile_package_id: number | null;
  profile: UserProfile;
  status: number;
  force_mcast?: number;
  deleted: number;
  default_user_language_id?: number;
  defaultUserLanguage?: UserLanguage;
  totalStorage?: number;
  leftStorage?: number;
  buying_allowed?: boolean;
  recording_allowed?: boolean;
  created_at?: number;
  updated_at?: number;
  expire?: string | null;
  last_online?: string;
  _links?: Links;
}

export interface ContentMedia {
  id: number;
  name: string;
  type: string;
  size: number;
  created_at: number;
  updated_at: number;
  title: string;
  url: string;
  thumb: string;
}

export interface MediaType {
  id: number;
  name: string;
}
export interface Category {
  id: number;
  name: Categories;
  channelsCount: number;
  channels?: MyChannel[];
  vodsCount: number;
  _links?: Links;
}
export interface CategoryList {
  items: Category[];
}

export interface MyChannel {
  active: number;
  id: number;
  name: string;
  default_position: number;
  channel_type_id: number;
  catchup: number;
  epg_url: string;
  product_id: number;
  is_product: number;
  stream_name: string;
  mcast_live: string;
  default_lock: number;
  media: ContentMedia;
  parentalLock: boolean;
  isFavorite: boolean;
  type: MediaType;
  canWatch: boolean;
  timesWatched: string;
  categories: Category[];
  videoLive: string;
  userOrder: number;
}
export interface ChannelList {
  items: MyChannel[];
}

export interface EpgItem {
  id: number;
  title: string;
  starttime?: string;
  endtime?: string;
  category?: string;
  premiere?: number;
  previously_shown?: number;
  channel_id: number;
  description: string;
  image: string;
  shortStartTime?: string;
  shortStartDate?: string;
  shortEndTime?: string;
  shortEndDate?: string;
  catchup_tv_url?: string;
  epgStarttime: string;
  epgEndtime: string;
}

export interface ChannelEpg {
  items: EpgItem[];
}

export interface UserChannelConfig {
  id: number;
  videoLive: string;
  parentalLock: boolean;
  canWatch: boolean;
  isFavorite: boolean;
  userOrder: number;
}

export interface BoundUser {
  id: number;
  first_name: string;
  last_name: string;
  role: UserRole;
  username: string;
}

export interface Promotions {
  items: Promotion[];
}

export interface Promotion {
  id: number;
  name: string;
  created_at: number;
  updated_at: number;
  text: string;
  media_id: number;
  activated: null | boolean;
  deactivated: null | boolean;
  channel_id: number;
  status: number;
  unlimited: number;
  provider_id: null | number;
  movie_id: null | number;
  tv_show_id: null | number;
  media: null | ContentMedia;
  channel: null | MyChannel;
  movie: null | Movie;
  tvShow: null | TvShow;
  _links: Links;
  _meta: PromotionsMeta;
}

export interface PromotionsMeta {
  totalCount: number;
  pageCount: number;
  currentPage: number;
  perPage: number;
}

export interface BuffetEpgItems {
  items: BuffetEpgItem[];
}

export interface BuffetEpgItem {
  id: number;
  title: string;
  starttime?: string;
  endtime?: string;
  category: string;
  premiere?: number;
  previously_shown?: number;
  channel_id: number;
  description: string;
  image: string;
  shortStartTime?: string;
  shortStartDate?: string;
  shortEndTime?: string;
  shortEndDate?: string;
  catchup_tv_url?: string;
  epgStarttime: null;
  epgEndtime: null;
}

export interface BuffetCategories {
  items: BuffetCategory[];
}

export interface BuffetCategory {
  id: number;
  code: string;
  name: BuffetCategoriesEnum;
  epgList?: BuffetEpgItem[];
  position: number;
  created_at: number;
  updated_at: number;
  _links?: Links;
}
export interface LockParams {
  time_from: null | string;
  time_to: null | string;
}

export interface ChannelToLock {
  id: number;
  channelLock: null | LockParams;
}

export interface ChannelsToLock {
  channels: ChannelToLock[];
}

export interface LockedChannelSuccess {
  success: string;
}

export interface CheckPinDto {
  pin_code: string;
}

export interface UpdatePinDto {
  pin_code: number;
  confirm_pin_code: number;
  old_pin_code: number;
}

export interface UserChildren {
  children: UserInfo[];
}

export interface UserUpdate {
  username: string;
  email: string;
  first_name: string;
  last_name: string;
  mobile_number: string;
  birth?: string | null;
  status?: number;
  force_mcast?: number;
  old_pin_code?: number;
  pin_code?: number;
  confirm_pin_code?: number;
  user_channel_package_id?: number;
  old_password: string;
  password: string;
  password_confirm: string;
  expire?: string | null;
}

export interface ChildUpdate extends UserUpdate {
  id: number;
}

export interface NewUser {
  username: string;
  role: UserRole;
  email: string;
  first_name: string;
  last_name: string;
  pin_code?: number;
  confirm_pin_code?: number;
  password: string;
  password_confirm: string;
}

export interface ChannelId {
  id: number;
}

export interface ProviderColorScheme {
  id: number;
  name: string;
  provider_id: number;
  mainDark: string;
  mainLight: string;
  accent: string;
  background: string;
  transparent: string;
  media_id: null | number;
  media: null | ProviderMedia;
}

export interface ProviderMedia {
  id: number;
  name: string;
  type: string;
  size: number;
  created_at: number;
  updated_at: number;
  title: string;
  url: string;
  thumb: string;
}

export interface ProviderData {
  id: number;
  name: string;
  description: string;
  status: number;
  created_at: number;
  updated_at: number;
  logo_id?: number;
  media: null | ProviderMedia;
  logo: null | ProviderMedia;
  colorScheme: ProviderColorScheme;
}

export interface ProviderDataList {
  items: ProviderData[];
}

export interface LanguageList {
  items: UserLanguage[];
  _links: {
    self: string;
  };
  _meta: {
    totalCount: number;
    pageCount: number;
    currentPage: number;
    perPage: number;
  };
}

export interface AppMenuItems {
  items: AppMenuItem[];
}

export interface AppMenuItem {
  id: number;
  name: AppMenuItemsPos;
  position: number;
  created_at: number;
  updated_at: number;
  provider_id?: number;
}

export interface HomePageWidget {
  id: number;
  name: string;
  channel_category: null | number;
  channel_favorites: null | FavoriteStatus;
  buffet_category: null | number;
  vod_category: null | number;
  vod_favorites: null | FavoriteStatus;
  vod_type: VoDType;
  provider_id: null | number;
  created_at: number;
  updated_at: number;
  position: number;
}

export interface Movie {
  id: number;
  name: string;
  studio?: string;
  keywords?: string;
  cast?: string;
  year?: string;
  director?: string;
  country?: string;
  description?: string;
  rating?: string;
  hd?: number;
  activated?: null | string;
  deactivated?: null | string;
  created_at: number;
  updated_at: number;
  media_id?: null | number;
  product_id?: null | number;
  is_product?: number;
  status?: number;
  file_name?: string;
  unlimited?: number;
  thumb_id?: null | number;
  provider_id: null | number;
  trailer_id?: null | number;
  brand_id?: null | number;
  media?: null | ContentMedia;
  trailer?: null | ContentMedia;
  thumb?: null | ContentMedia;
  genres?: Genre[];
}

export interface TvShow {
  id: number;
  name: string;
  studio?: string;
  keywords?: string;
  cast?: string;
  year?: string;
  director?: string;
  country?: string;
  description?: string;
  rating?: string;
  activated?: null | string;
  deactivated?: null | string;
  created_at: number;
  updated_at: number;
  media_id?: null | number;
  product_id?: null | number;
  is_product?: number;
  status?: number;
  unlimited?: number;
  thumb_id?: null | number;
  provider_id: null | number;
  trailer_id?: null | number;
  brand_id?: null | number;
  media?: null | ContentMedia;
  trailer?: null | ContentMedia;
  thumb?: null | ContentMedia;
  genres?: Genre[];
  seasons?: Season[];
}

export interface Season {
  id: number;
  name: string;
  activated?: null | string;
  deactivated?: null | string;
  created_at: number;
  updated_at: number;
  status: boolean;
  unlimited: boolean;
  tv_show_id: number;
  episodes: Episode[];
}

export interface Episode {
  id: number;
  name: string;
  studio?: string;
  keywords?: string;
  cast?: string;
  year?: string;
  director?: string;
  country?: string;
  description?: string;
  rating?: string;
  hd?: number;
  activated?: null | string;
  deactivated?: null | string;
  created_at: number;
  updated_at: number;
  media_id?: null | number;
  product_id?: null | number;
  is_product?: number;
  status?: number;
  file_name?: string;
  unlimited?: number;
  season_id: number;
  episode_nuber: number;
  trailer_id?: null | number;
  media?: null | ContentMedia;
  trailer?: null | ContentMedia;
  duration?: string; // custom property for storing each episode duration for metadata
}

export interface Genre {
  id: number;
  name: string;
}

export interface Movies {
  items: Movie[];
}

export interface TvShows {
  items: TvShow[];
}

export interface VoDGenre {
  id: number;
  name: string;
  order: number;
  latestMovies?: Movie[];
  latestTvShows?: TvShow[];
}

export interface VoDGenres {
  items: VoDGenre[];
}

export interface LoginCredentials {
  token: string;
  deviceId: string;
}
